import Layout from "@/views/layout";

const cashbook = {
  path: "/cashbook",
  name: "cashbook",
  component: Layout,
  meta: {
    title: "资金账本"
  },
  children: [{
      path: "cashbooks",
      name: "cashbooks",
      component: () => import("@/views/cashbook/cashbooks"),
      meta: {
        title: "资金账本"
      }
    }
  ]
};

export default cashbook;